const Illustration = require.context('./resources', true, /\.(svg|jpeg|jpg|png|webp)$/);
export function getIllustrationSrc(name, format = 'svg') {
    return Illustration(`./${format}/${name}.${format}`);
}
